import { httpInstance } from '@/clients/http.request';
import { showError } from '@/composables/useToast';
import { urlFiles, urlMail, urlSiniestro } from '@/helpers';

export const setSearchData = async ({ commit }, formSearch) => {
   commit('SET_SEARCH_DATA', formSearch);
};
export const setPolizaDenunciar = async ({ commit }, rowData) => {
   commit('SET_POLIZA_DENUNCIA', rowData);
};
export const setLotes = async ({ commit }, id_poliza) => {
   try {
      const lotes = await httpInstance.get(
         `${urlSiniestro}/lotesByPolizaSiniestro?id_poliza=${id_poliza}`,
      );
      commit('setLotes', lotes.data);
   } catch (error) {
      throw error;
   }
};
export const getPolizas = async ({ commit }, data) => {
   try {
      const polizas = await httpInstance.get(
         `${urlSiniestro}/polizasSiniestro`,
         data,
      );
      commit('setPolizas', polizas.data);
      return polizas.data;
   } catch (error) {
      throw error;
   }
};
export const setSiniestro = async ({ commit }, data) => {
   try {
      const siniestros = await httpInstance.post(
         `${urlSiniestro}/create`,
         data,
      );
      commit('resetState', null);
   } catch (error) {
      throw error;
   }
};

export const sendEmailAgroEDC = async ({ commit }, data) => {
   try {
      const response = await httpInstance.post(
         `${urlMail}/notifyAgroEDC`,
         data,
         false,
      );
      return response;
   } catch (error) {
      throw error;
   }
};

export const loadFileSiniestro = async ({ commit }, data) => {
   const formData = new FormData();
   formData.append('files', data.file);
   formData.append('id_poliza', data.id_poliza);

   try {
      const response = await httpInstance.post(
         `${urlFiles}/siniestros`,
         formData,
         true,
      );
      return response.data;
   } catch (error) {
      throw error;
   }
};
export const removeFileSiniestro = async ({ commit }, hash_id) => {
   try {
      const response = await httpInstance.delete(
         `${urlFiles}/removeFile?hash_id=${hash_id}`,
      );
      return response;
   } catch (error) {
      throw error;
   }
};
export const getFile = async ({ commit }, hash_id) => {
   try {
      const response = await httpInstance.get(
         `${urlFiles}/getFile?hash_id=${hash_id}`,
      );
      return response.data;
   } catch (error) {
      throw error;
   }
};
